import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../../utils/request';

const getCoMissingParts = createAsyncThunk('coOrders/getCoMissingParts',
  async ({ id }, { rejectWithValue }) => {
    try {
      return await authGet(`/co/orders/missing_parts/${id}`);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getCoMissingParts;
